var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (locations, undefined) {
buf.push("<div class=\"partner2-overview-locations\"><ul class=\"partner2-locations-list\">");
// iterate locations
;(function(){
  var $$obj = locations;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var location = $$obj[$index];

buf.push("<li class=\"partner2-location\">" + (null == (jade_interp = location.toHtml()) ? "" : jade_interp) + "</li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var location = $$obj[$index];

buf.push("<li class=\"partner2-location\">" + (null == (jade_interp = location.toHtml()) ? "" : jade_interp) + "</li>");
    }

  }
}).call(this);

buf.push("</ul></div>");}.call(this,"locations" in locals_for_with?locals_for_with.locations:typeof locations!=="undefined"?locations:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;